import React from "react";
import { Space } from "antd";
import { AxSpinner, AxDivider } from "@dynata/axiom3";

class Spinner extends React.Component {
  render() {
    return (
      <div className="section" id="spinner">
        <h3>Spinner</h3>
        <p>A spinner for displaying loading state of a page or a section.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxSpinner size="small" />`}</pre>
            <p className="props-title">Props</p>
            <table className="props-table">
              <tbody>
                <tr>
                  <th>Property</th>
                  <th>Value</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>size</td>
                  <td>"small | medium | large"</td>
                  <td>Size of the spinner</td>
                </tr>
              </tbody>
            </table>
          </Space>
          <Space>
            <AxSpinner size="small" />
            <AxSpinner size="medium" />
            <AxSpinner size="large" />
          </Space>
        </Space>
      </div>
    );
  }
}
export default Spinner;
